// extracted by mini-css-extract-plugin
module.exports = {"body-text-1":"TypographyBody_body-text-1__2J90u","body-text-2":"TypographyBody_body-text-2__3ak-y","bold":"TypographyBody_bold__KyLBa"};